
import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonPage, IonContent, IonFooter, useIonViewDidEnter } from '@ionic/react'
import { UseHeader, MktButton, AddressItem, AddressEditModal, MktEmpty } from '@cps'
import { useHistoryNew, modalLayer } from '@utils'
import { memberMobx } from '@mobxStore'
import { cloneDeep } from '@dt/fe-utils/dist/lodash'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import './index.scss'
interface IProps {
}

const MyAddress: FC<IProps> = () => {
  const history = useHistoryNew()
  const { getMemberAddress } = memberMobx
  const editAddress = (info: any) => {
    const resInfo: any = cloneDeep(info)
    resInfo.lng = Number(resInfo.lng)
    resInfo.lat = Number(resInfo.lat)
    modalLayer(AddressEditModal, { info: resInfo }, 'AddressEditModal').then(() => { }, () => { })
  }
  const addAddress = () => {
    modalLayer(AddressEditModal, { info: null }, 'AddressEditModal').then(() => { }, () => { })
  }
  const deleteAddress = (info: any) => {
    memberMobx.deleteMemberAddress(info.memberAddressId)
  }
  const defaultAddress = (info: any) => {
    memberMobx.updateMemberAddress({
      ...info,
      isDefault: true
    })
  }
  useIonViewDidEnter(() => {
    getMemberAddress()
  })
  return (
    <IonPage className='my-address-page'>
      <UseHeader title={i18n.t('mkt.common.shippingAddress')} onBack={() => mktController.goBack(history)} />
      <IonContent className='page-content'>
        {
          memberMobx.addressList.length > 0 ? (
            <div className='address-list'>
              {
                memberMobx.addressList.map((item: any, index: number) => {
                  return <AddressItem key={index} info={item} onEdit={() => editAddress(item)} onDelete={() => deleteAddress(item)} onDefault={() => defaultAddress(item)}></AddressItem>
                })
              }
            </div>
          ) : <MktEmpty />
        }
      </IonContent>
      <IonFooter>
        <div className='page-footer'>
          <div className='tip-text'>{i18n.t('common.reminder')}: {i18n.t('location.delAddressTip')}</div>
          <MktButton onClick={addAddress}>
            <span>{i18n.t('location.addShippingAddress')}</span>
          </MktButton>
        </div>
      </IonFooter>
    </IonPage>
  )
}

export default observer(MyAddress)
